// extracted by mini-css-extract-plugin
module.exports = {"uploadText":"UploadButton_uploadText__1v3jv","uploadButton":"UploadButton_uploadButton__pRMdm"};